import Success from "../../../jsx/pages/Success";

const SuccessWrapper = function () {
  return <Success />;
};

export default constore(SuccessWrapper);
